import type { IModuleI18n, Lang } from '@platform/core/types';
import { i18n } from './i18n';

/** Namespace i18n пакета модуля: сюди loadModule додає i18n/<мова>.json пакета. */
export const moduleNamespace = (moduleKey: string): string => `module.${moduleKey}`;

/** Рядки пакета модуля для мови зі сховища i18n або undefined, доки пакет не завантажено (рушій тоді показує підписи визначення). */
export function moduleBundle(lang: Lang, moduleKey: string): IModuleI18n | undefined {
  if (!moduleKey || !i18n.isInitialized || !i18n.hasResourceBundle(lang, moduleNamespace(moduleKey))) return undefined;
  return i18n.getResourceBundle(lang, moduleNamespace(moduleKey)) as IModuleI18n;
}
